import { TextField, FormLayout, Form, Modal, Select } from '@shopify/polaris';
import React, { useState, useEffect } from 'react';
import { currenciesJSON } from '../../../helpers/currenciesList';
import { getDepositById, listGroups } from '../../../services/depositsService';
import { DEPOSIT_TYPE_OPTIONS } from '../../../helpers/depositTypes';

const EditDepositModal = ({ id, active, onSubmit, onClose, onDelete }) => {
  const [edit, setEdit] = useState({ name: '', code: '', currency: '', isOnlyGroup: false, parentId: null });
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    Promise.all([getDepositById(id), listGroups()]).then(([deposit, g]) => {
      setEdit(deposit.data);
      setGroups(g.data.data);
    });
    // eslint-disable-next-line
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Solo los campos que admite joiValidatorUpdateDeposit: el objeto `edit`
    // trae la ficha completa (id, totales de stock...) y el back rechaza
    // claves desconocidas.
    const payload = { name: edit.name, code: edit.code, parentId: edit.parentId };
    if (!edit.isOnlyGroup) {
      payload.currency = edit.currency;
      payload.depositType = edit.depositType || 'warehouse';
    }
    onSubmit(payload);
  };

  const handleDelete = () => {
    if (!window.confirm('¿Estás seguro de que quieres eliminar este depósito?')) return;
    onDelete();
  };

  const groupOptions = [
    { label: 'Sin grupo', value: '' },
    ...groups.map((g) => ({ label: g.name, value: g.id })),
  ];

  const secondaryActions = [{ content: 'Cancelar', onAction: onClose }];
  if (onDelete) secondaryActions.unshift({ content: 'Eliminar', destructive: true, onAction: handleDelete });

  return (
    <Modal
      open={active}
      onClose={onClose}
      title="Editar depósito"
      primaryAction={{ content: 'Guardar', onAction: handleSubmit }}
      secondaryActions={secondaryActions}
    >
      <Modal.Section>
        <Form onSubmit={handleSubmit}>
          <FormLayout>
            <TextField
              label="Nombre"
              type="name"
              placeholder={edit.name}
              value={edit.name}
              autoComplete="off"
              onChange={(e) => setEdit({ ...edit, name: e })}
            />
            <TextField
              label="Código"
              type="name"
              placeholder={edit.code}
              value={edit.code}
              autoComplete="off"
              onChange={(e) => setEdit({ ...edit, code: e })}
            />
            {!edit.isOnlyGroup && (
              <Select
                label="Moneda"
                options={currenciesJSON.map((e) => ({ label: `(${e.code}) ${e.name}`, value: e.code }))}
                onChange={(e) => setEdit({ ...edit, currency: e })}
                value={edit.currency}
              />
            )}
            {!edit.isOnlyGroup && (
              <Select
                label="Grupo padre"
                options={groupOptions}
                value={edit.parentId || ''}
                onChange={(v) => setEdit({ ...edit, parentId: v || null })}
              />
            )}
            {!edit.isOnlyGroup && (
              <Select
                label="Rol (informes)"
                helpText="Tienda, outlet, córner, pop-up y venta remota forman el perímetro de venta de los informes. El resto queda fuera."
                options={DEPOSIT_TYPE_OPTIONS}
                value={edit.depositType || 'warehouse'}
                onChange={(v) => setEdit({ ...edit, depositType: v })}
              />
            )}
          </FormLayout>
        </Form>
      </Modal.Section>
    </Modal>
  );
};

export default EditDepositModal;
